/**
 * The "about" strip at the top of a patient thread (staff chat MVP, SR-14; the catalog's proposal, "ask Samer"):
 * "About <name> · <MRN>" and Open patient. Identity only, by contract: it never shows clinical content. Shown only with
 * the patient switch (?x=staff-chat-patient), which is off.
 */
import { Link } from 'react-router-dom';
import type { StaffChatPatientRef } from '@/staff-chat/types/staff-chat';

export function PatientThreadCard({ patient }: { patient: StaffChatPatientRef }) {
  const name = patient.name ?? 'Patient record unavailable';
  return (
    <section className="team-chat-about" data-slot="team-chat-about" aria-label="Patient">
      <span className="home-pill">{patient.mrn ? `About ${name} · ${patient.mrn}` : `About ${name}`}</span>
      <Link className="team-chat-link" to={`/patients/edit/${encodeURIComponent(patient.id)}?tab=chart`}>
        Open patient
      </Link>
    </section>
  );
}
